import React, { useEffect, useMemo } from 'react';
import FilterSelectDropdown from 'src/components/10-atoms/filters/FilterSelectDropdown';
import SortIcon from 'src/components/10-atoms/icons/SortIcon';
import useIsOnline from 'src/components/10-atoms/network/hooks/useIsOnline';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import { QuestionSearchSortBy } from 'src/modules/exam-preparation/graphql/question/types';
const ALL_OPTIONS = [{
        id: QuestionSearchSortBy.TOPICS,
        title: 'Topics',
    }, {
        id: QuestionSearchSortBy.QP_DATE,
        title: 'Question Paper Date',
    }, {
        id: QuestionSearchSortBy.DUPLICATES_COUNT,
        title: 'Most Repeated',
    }, {
        id: QuestionSearchSortBy.MOST_READ,
        title: 'Most Read (past 3 days)',
    }, {
        id: QuestionSearchSortBy.MOST_BOOKMARKED,
        title: 'Most Bookmarked (past 3 days)',
    }, {
        id: QuestionSearchSortBy.RELEVANCE,
        title: 'Search Relevance',
    }];
const OFFLINE_ALLOWED_OPTIONS = [
    QuestionSearchSortBy.TOPICS,
    QuestionSearchSortBy.QP_DATE,
    QuestionSearchSortBy.DUPLICATES_COUNT,
];
const OFFLINE_OPTIONS = ALL_OPTIONS.filter(option => OFFLINE_ALLOWED_OPTIONS.includes(option.id));
const SortBy = ({ value, onChange }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    const isOnline = useIsOnline();
    const availableOptions = useMemo(() => (isOnline ? ALL_OPTIONS : OFFLINE_OPTIONS), [isOnline]);
    const selectedOption = availableOptions.find(option => option.id === value);
    useEffect(() => {
        if (!selectedOption) {
            onChange(availableOptions[0].id);
        }
    }, [selectedOption, availableOptions, onChange]);
    return (React.createElement(FilterSelectDropdown, { value: value, onChange: onChange, options: availableOptions, title: "Sort Questions by", selected: false, spacing: theme.spacing.standard.xxs, LeftIcon: SortIcon }));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default SortBy;
